
export default {
  setToken(state, token) {
    state.access_token = token.access_token
    state.refresh_token= token.refresh_token;
    state.expires_in = token.expires_in
    window.localStorage.setItem('access_token', token.access_token);
    window.localStorage.setItem('refresh_token', token.refresh_token);
    window.localStorage.setItem('expires_in',token.expires_in)
  },
  setCertification(state, certification) {
    state.certification = certification
    window.localStorage.setItem('certification', certification);
  },
  setExpiresIn(state,expiresIn) {
    state.expires_in = expiresIn
    window.localStorage.setItem('expires_in',expiresIn)
  },
  setUserInfo(state,userInfo){
    state.user_info = userInfo
    window.localStorage.setItem('user_info',userInfo)
  },
  // setUserMenu(state,userMenu) {
  //   if (userMenu[0] === '0'){
  //     const menu = [ {path:'/pendSubmit',title:'待提交事项'},
  //       {path:'/auditProgress',title:'审核进度'},]
  //     state.user_menu = menu
  //     window.localStorage.setItem('user_menu',menu)
  //   }else if (userMenu[0] === '1') {
  //     const menu2 = [
  //       {path:'/pendSubmit',title:'待提交事项'},
  //       {path:'/pendAudit',title:'待审核事项'},
  //       {path:'/auditProgress',title:'审核进度'},]
  //     state.user_menu = menu2
  //     window.localStorage.setItem('user_menu',menu2)
  //   }else {
  //     const menu3 = []
  //     state.user_menu = menu3
  //     window.localStorage.setItem('user_menu',menu3)
  //   }
  //
  // },
  cleanLocal(state){
    window.localStorage.clear()
    state.user_info = ''
    state.certification = 0
  },
  openLogin(state,to){
    state.openLoginBox = true //打开登陆盒子
    state.toSave = to
  },
  closeLogin(state){
    state.openLoginBox = false //关闭登录盒子
  },
  //设置待提交待审核事项
  // setPendingNum(state,number){
  //   state.pendNum = number
  // },
  // setSubmitNum(state,number) {
  //   state.pendSubmitNumber = number
  // }
}
